import { render, staticRenderFns } from "./TermsLines.vue?vue&type=template&id=2bbbd6b2&"
import script from "./TermsLines.vue?vue&type=script&lang=js&"
export * from "./TermsLines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports